import React, { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';

import Cargando from './components/layout/Cargando';
import DeeplinkHandler from './components/layout/Deeplink';
import ProtectedRoute from './config/ProtectedRoute';

const Home = lazy(() => import('./components/home/Home'));
const Onboarding = lazy(() => import('./components/layout/Onboarding'));

function App({ msalInstance }) {
    return (
        <MsalProvider instance={msalInstance}>
            <Suspense fallback={<Cargando />}>
                <Routes>
                    <Route path="/" element={<Onboarding />} />
                    <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
                    <Route path="/deeplink/*" element={<DeeplinkHandler />} />
                    <Route path="*" element={<Onboarding />} />
                </Routes>
            </Suspense>
        </MsalProvider>
    );
}

export default App;
